import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const boxStyle = {
    padding: '10px 16px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#f1f9ff'
};

export const menuStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0'
};

export const ulStyle = {
    display: 'flex',
    listStyleType: 'none',
    padding: 0,
};

export const MenuFilter = ({ title, items, checkedItems, setCheckedItems }) => {
  
    const handleCheckboxChange = (item) => {
        setCheckedItems((prev) =>
            prev.includes(item)
                ? prev.filter((i) => i !== item) // Remove if already checked
                : [...prev, item] // Add if not checked
        );
    };

    return (
        <div style={menuStyle}>
            <h5 style={{ width: "5rem", minWidth: "4rem" }}>{title}</h5>
            <ul style={ulStyle}>
                {items.map((item) => (
                    <li key={item} style={{ marginRight: "10px" }}>
                        <label htmlFor={item} style={{ fontSize: "0.9rem" }}>
                            <input
                                id={item}
                                type="checkbox"
                                checked={checkedItems.includes(item)}
                                onChange={() => handleCheckboxChange(item)}
                                style={{ marginRight: "5px" }}
                            />
                            {item}
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export const RadioFilter = ({ title, items, selectedItem, setSelectedItem }) => {

  const handleRadioChange = (event) => {
    setSelectedItem(event.target.value);
  };

  const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    '& .MuiFormControlLabel-label': {
      fontSize: '0.8rem'
    },
  }));

  const CustomRadio = styled(Radio)(({ theme }) => ({
    marginLeft: '6px',
    padding: '4px',
    '&.Mui-checked': {
      color: 'blue',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '0.8rem',
    },
  }));

  return (
    <div style={menuStyle}>
      <h5 style={{ width: "5rem", minWidth: "4rem" }}>{title}</h5>
      <FormControl component="fieldset">
        <RadioGroup 
          row 
          value={selectedItem} 
          onChange={handleRadioChange} 
          defaultValue={items[0]}
          sx={{ gap: 1 }}
        >
          {items.map((item) => (
            <CustomFormControlLabel
              key={item}
              value={item}
              control={<CustomRadio size="small" />} // 👈 Smaller radio button
              label={item}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};
